import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
const google = (props) => (
  <SvgIcon viewBox="0 0 15.359 15.5" {...props}>
    <g transform="translate(0 440)">
      <path transform="translate(0 -424.5)" />
      <path transform="translate(0 -424.5)" />
      <path transform="translate(0 -424.5)" />
      <path
        d="M51.081-433.941v2.431h4.051a3.868,3.868,0,0,1-4.051,3.03,4.376,4.376,0,0,1-4.333-4.439,4.376,4.376,0,0,1,4.333-4.439,3.9,3.9,0,0,1,2.818,1.092l1.9-1.832a6.559,6.559,0,0,0-4.756-1.9A7,7,0,0,0,44-432.955a7.021,7.021,0,0,0,7.045,7.045,6.481,6.481,0,0,0,6.764-6.869,4.213,4.213,0,0,0-.106-1.2H51.081Z"
        transform="translate(-42.45 0)"
      />
    </g>
  </SvgIcon>
);
export default google;



// WEBPACK FOOTER //
// ./src/common/icons/Google/index.tsx